const poBoxPattern = /(^|\s)p(?:ost)?[\s.]*o(?:ffice)?[\s.]*box/i;

export function isPoBoxAddress(address: string) {
    return poBoxPattern.test(address);
}
